import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import Recycle from "../components/recycle.jsx";
import Footer from "../components/footer.jsx";

function qrCodePage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <Recycle/> 
        </div>
        <Footer /> 
      </div>
      );
}
export default qrCodePage;